import { ArtPipelineCore } from "./art";
import { loadDropfrontArtPack } from "./data/art/dropfront-pack";
import { loadFrontlineArtPack } from "./data/art/frontline-pack";
import { loadPortalFfaArtPack } from "./data/art/portal-ffa-pack";
import { loadRaidArtPack } from "./data/art/raid-pack";
import { loadInfiniteWarArtPack } from "./data/art/infinite-war-pack";
import { gameConfig } from "./game/config";
import { sharedInput } from "./input/input-controller";
import { setupMobileControls } from "./input/mobile-controls";
import { createUiLayout } from "./ui/layout";
import Phaser from "phaser";
import "./styles.css";

ArtPipelineCore.registerPack(loadPortalFfaArtPack());
ArtPipelineCore.registerPack(loadDropfrontArtPack());
ArtPipelineCore.registerPack(loadFrontlineArtPack());
ArtPipelineCore.registerPack(loadRaidArtPack());
ArtPipelineCore.registerPack(loadInfiniteWarArtPack());

if (!(window as unknown as { __gameProtoErrorsHooked?: boolean }).__gameProtoErrorsHooked) {
  (window as unknown as { __gameProtoErrorsHooked?: boolean }).__gameProtoErrorsHooked =
    true;
  window.addEventListener("error", (ev) => {
    console.error("[GameProto] window.onerror", ev.error ?? ev.message, ev);
  });
  window.addEventListener("unhandledrejection", (ev) => {
    console.error("[GameProto] unhandledrejection", ev.reason);
  });
}

document.documentElement.dataset.inputMode =
  navigator.maxTouchPoints > 0 ||
  window.matchMedia("(pointer: coarse)").matches ||
  "ontouchstart" in window
    ? "touch"
    : "keyboard";

sharedInput.attach();
setupMobileControls();

const game = new Phaser.Game(gameConfig);
const uiLayout = createUiLayout(game);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    uiLayout.destroy();
    sharedInput.detach();
    game.destroy(true);
  });
}
